module.exports = __webpack_public_path__ + "static/media/Sivir.c0bb039c.png";